var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.756 25.428A2.741 2.741 0 008 27.322c0 .732.286 1.398.753 1.891l-.001-.001a2.503 2.503 0 003.64.008l10.856-11.324c.466-.493.752-1.16.752-1.894s-.286-1.401-.754-1.895l.001.001-10.856-11.32A2.513 2.513 0 0010.572 2h-.001a2.512 2.512 0 00-1.811.783l-.001.001c-.466.493-.752 1.16-.752 1.894s.286 1.401.754 1.895l-.001-.001L17.796 16l-9.04 9.428z"
  })));
}
export default SvgArrowRight;